import { DynamicFormContent } from 'common.types'
import { useApi } from 'hooks/use-api/use-api'
import useLocalStorageState from 'hooks/use-localstorage-state/use-localstorage-state'
import { useEffect } from 'react'

let hasInitialized = false
const TIME_ZONE = 'America/New_York'

export const useDynamicFormContent = () => {
  const { getFormContent } = useApi()
  const [formContent, setFormContent] =
    useLocalStorageState<DynamicFormContent>('formContent', {
      formOverrides: {},
      oneStop: {},
    })

  const isUtcZDatestamp = (input: string) =>
    typeof input === 'string' &&
    /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.*Z$/.test(input)

  const toPADate = (value?: string | Date) =>
    new Date(
      new Date(value ?? Date.now()).toLocaleString('en-US', {
        timeZone: TIME_ZONE,
      }),
    )

  useEffect(() => {
    const initialize = async () => {
      if (!hasInitialized) {
        const content = await getFormContent()
        setFormContent(content)
        setTimeout(() => {
          hasInitialized = true
        }, 100)
      }
    }
    initialize()
  }, [getFormContent, setFormContent])

  const now = new Date().getTime()

  const parseElectionDate = (dateString?: string): Date | undefined => {
    if (!dateString) return undefined
    return isUtcZDatestamp(dateString)
      ? new Date(dateString)
      : toPADate(dateString)
  }

  const mailInBallotDeadlineDate = parseElectionDate(
    formContent?.dates?.mailInBallotDeadline?.date,
  )

  const registrationDeadlineDate = parseElectionDate(
    formContent?.dates?.voterRegistrationDeadline?.date,
  )

  return {
    toPADate,
    formContent,
    hasLoaded: hasInitialized,
    mailinBallotDeadlinePassed:
      !!mailInBallotDeadlineDate && now > mailInBallotDeadlineDate.getTime(),
    registrationDeadlinePassed:
      !!registrationDeadlineDate && now > registrationDeadlineDate.getTime(),
  }
}
